import { Icon } from '@frontend/icons';
import { Text, styles } from '@frontend/design-system';
import { ThreadAttachedAsset } from '../../types';
import { chipContainer, chipIcon, chipText } from './attached-asset-chip.styles';

type AttachedAssetChipProps = {
  asset: ThreadAttachedAsset;
};

export const AttachedAssetChip = ({ asset }: AttachedAssetChipProps) => {
  return (
    <li className={chipContainer}>
      <Icon name={asset.iconName ?? 'document-small'} size={16} color='light' className={chipIcon} />
      <Text as='span' size='small' color='light' css={[styles.truncate]} className={chipText}>
        {asset.name}
      </Text>
    </li>
  );
};
